import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface InvoiceListTotalTTCHeaderProps
  extends HeaderContext<InvoiceModel, InvoiceModel['totalTTC']> {}

export const InvoiceListTotalTTCHeader =
  (): // props: InvoiceListTotalTTCHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-invoice.total-ttc');
  };
